<template>
  <div class="navbar navbar-dark bg-dark navbar-expand-lg">
    <div class="row">
      <div class="col main-nav">
        <router-link :to="{ name: 'home' }">
          <img src="@/assets/img/opoint-logo.svg" alt="Opoint" class="logo">
        </router-link>
        <span class="navbar-text">{{ name }}</span>
      </div>
      <div class="col auth">
        <span class="navbar-text username">{{ displayName }}</span>
        <button type="button" class="btn btn-outline-light logout-button" @click="logOut">Log out</button>
      </div>
    </div>
  </div>
</template>

<script>
import { NAME } from '@/constants'

export default {
  name: 'Navbar',
  methods: {
    logOut() {
      this.$store.commit('auth/logOut')
      this.$router.push({ name: 'login' })
    }
  },
  computed: {
    name() {
      return NAME
    },
    displayName() {
      if (this.$store.getters['auth/isLoggedIn'] && 'username' in this.$store.state.auth.auth.state.user) {
        return this.$store.state.auth.auth.state.user.display_name || this.$store.state.auth.auth.state.user.username
      }
      return 'Unknown';
    }
  }
}
</script>

<style lang="sass">
@import '@/styles/default.sass'

.navbar
  background-color: $opoint-blue !important
  z-index: $zindex-fixed
  height: $navbar-height
  position: fixed
  top: 0
  left: 0
  width: 100%

  .row
    width: 100%

    .main-nav
      display: flex
      align-items: center
      gap: 12px

    .col.auth
      text-align: right

      .username
        margin: 0.5rem 10px

      .logout-button
        float: right

  .btn
    margin: 0.5rem 0

  .navbar-text
    font-weight: 300
    color: $white
    font-size: $font-size
    margin-right: 8px
    font-family: 'Roboto', sans-serif

    &:hover
      text-decoration: none

  .logo
    height: 30px

</style>
